import { EntityType } from "@mapmycustomers/shared/enum";
import Route, { RoutePreview } from "@mapmycustomers/shared/types/entity/Route";
import GeoPoint from "@mapmycustomers/shared/types/shapes/GeoPoint";

import decodePolyline from "@app/util/map/decodePolyline";

const getPreviewStopGeoPoint = (
  stop: RoutePreview["stopTime"][number]
): GeoPoint | null | undefined => {
  if (stop.entity === EntityType.COMPANY || stop.entity === EntityType.PERSON) {
    return stop.geoPoint;
  }
  return stop.manualGeoPoint;
};

const computeRouteBounds = (
  route: Route,
  routePreview?: RoutePreview
): google.maps.LatLngBounds => {
  const bounds = new google.maps.LatLngBounds();

  if (routePreview?.polyline) {
    decodePolyline(routePreview.polyline).forEach(([lng, lat]) => {
      bounds.extend({ lat, lng });
    });
  }

  (routePreview?.stopTime ?? []).forEach((stop) => {
    const geoPoint = getPreviewStopGeoPoint(stop);
    if (geoPoint) {
      const [lng, lat] = geoPoint.coordinates;
      bounds.extend({ lat, lng });
    }
  });

  if (route.routeDetail.startGeoPoint) {
    const [lng, lat] = route.routeDetail.startGeoPoint.coordinates;
    bounds.extend({ lat, lng });
  }

  if (route.routeDetail.endGeoPoint) {
    const [lng, lat] = route.routeDetail.endGeoPoint.coordinates;
    bounds.extend({ lat, lng });
  }

  return bounds;
};

export default computeRouteBounds;
